import React from "react";

const OnboardingProgressBar: React.FC<{
  pages: readonly string[];
  currentPageIndex: number;
}> = ({ pages, currentPageIndex }) => {
  return (
    <nav className="flex items-center justify-center" aria-label="Progress">
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {pages.map((page, index) => (
          <li key={page}>
            {index < currentPageIndex ? (
              <div className="block h-2.5 w-2.5 rounded-full bg-indigo-600 hover:bg-indigo-900">
                <span className="sr-only">{page}</span>
              </div>
            ) : index === currentPageIndex ? (
              <div
                className="relative flex items-center justify-center"
                aria-current="step"
              >
                <span className="absolute flex h-5 w-5 p-px" aria-hidden="true">
                  <span className="h-full w-full rounded-full bg-indigo-200" />
                </span>
                <span
                  className="relative block h-2.5 w-2.5 rounded-full bg-indigo-600"
                  aria-hidden="true"
                />
                <span className="sr-only">{page}</span>
              </div>
            ) : (
              <div className="block h-2.5 w-2.5 rounded-full bg-gray-200 hover:bg-gray-400">
                <span className="sr-only">{page}</span>
              </div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default OnboardingProgressBar;
